import React from "react";
import { Stack, Typography } from "@mui/material";

import { useGetLaborDataByRouteId } from "../../hooks";
import { useGetWorkOrderRoutingRoute } from "../../hooks/react-query/useWorkOrderRouting";
import { HubIcon } from "../../components";

import { StyledSubStack } from "./styles";
import LaborTable from "./LaborTable";
import { SubRoutesTable } from "../SubRoutesTable";

const EmptyLabor = () => (
  <Stack gap="8px" alignItems="center" py="20px" sx={{ opacity: 0.5 }}>
    <HubIcon icon="Clock" size={20} />
    <Typography variant="caption" fontSize={11}>
      No labor tickets recorded
    </Typography>
  </Stack>
);

const WorkOrderRoutingLabor = ({ routeId }) => {
  const { data: laborData } = useGetLaborDataByRouteId(routeId);
  const { data: subRouteData } = useGetWorkOrderRoutingRoute(routeId);

  const hasLabor = laborData?.length > 0;
  const hasSubRoutes = subRouteData?.length > 0;

  return (
    <StyledSubStack gap="25px">
      {hasLabor ? (
        <Stack gap="10px">
          <Typography variant="boldCaptionL" fontSize={12}>
            Labor
          </Typography>
          <LaborTable routeId={routeId} />
        </Stack>
      ) : (
        <EmptyLabor />
      )}
      {hasSubRoutes && (
        <Stack gap="10px">
          <Typography variant="boldCaptionL" fontSize={12}>
            Subroutes
          </Typography>
          <SubRoutesTable routeId={routeId} />
        </Stack>
      )}
    </StyledSubStack>
  );
};

export default WorkOrderRoutingLabor;
